import React from 'react';
import { BondInsuranceForGetCompleteBondInsuranceProposalByIdResponseDTO } from '../../../../../dtos/bond-insurance-proposal-list/get-complete-bond-insurance-proposal-by-id-response.dto';

export type Props = {
  bondInsurance: BondInsuranceForGetCompleteBondInsuranceProposalByIdResponseDTO;
};

const FieldDisplay = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <div style={{ paddingBottom: '16px' }}>
    <div
      style={{
        fontWeight: 'bold',
        marginBottom: '0.35em',
        color: '#555',
        fontSize: '0.85em',
        textTransform: 'uppercase'
      }}
    >
      {label}
    </div>
    <div style={{ fontSize: '0.95em', wordBreak: 'break-word' }}>
      {value || 'Indisponível'}
    </div>
  </div>
);

export const BondInsuranceOwnerDetails = (props: Props) => {
  const { bondInsurance } = props;
  const ownerData = bondInsurance.ownerData;
  const address = ownerData?.address;

  return (
    <div className="row" style={{ paddingLeft: '8px', paddingRight: '8px' }}>
      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="NOME" value={ownerData?.name} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay label="CPF/CNPJ" value={ownerData?.cpf || ownerData?.cnpj} />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="CEP" value={address?.zip_code} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay label="RUA" value={address?.street} />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="N°" value={address?.number} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay label="BAIRRO" value={address?.district} />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="CIDADE" value={address?.city} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay label="UF" value={address?.state} />
        </div>
      </div>

      {address?.complement && (
        <div style={{ display: 'flex', width: '100%' }}>
          <div style={{ flex: 1, boxSizing: 'border-box' }}>
            <FieldDisplay label="COMPLEMENTO" value={address.complement} />
          </div>
        </div>
      )}
    </div>
  );
};
